export { default as Component } from "./Accordion.svelte";
export const modes = ["static"];
